type LogEntryMessage = Error | string;

interface LogEntryMeta {
  logType?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [meta: string]: any;
}

/**
 * LogEntry is the basic shape of all logs.
 */
type LogEntry = { message: LogEntryMessage } & LogEntryMeta;

/**
 * newLogEntry is a helper method compatible with passing either an entry,
 * or a message and an entry. This signature makes it compatible with most
 * logger uses.
 */
function newLogEntry(entryOrMessage: LogEntry | LogEntry['message'], messageMeta: LogEntryMeta = {}): LogEntry {
  if (typeof entryOrMessage === 'string' || entryOrMessage instanceof Error) {
    return {
      message: entryOrMessage,
      ...messageMeta,
    };
  }

  return {
    ...entryOrMessage,
  };
}

/**
 * RequestLogEntry is a helper type for `Logger.request`. See request plugin for
 * normalization applied to log outputs.
 *
 * FIXME: This probably doesn't belong here.
 */
type RequestLogEntry = {
  url: string;
  method?: string;
  status?: number;
} & LogEntry;

export { newLogEntry };
export type { LogEntryMessage, LogEntryMeta, LogEntry, RequestLogEntry };
